<template>
  <v-dialog v-model="isActive" fullscreen hide-overlay transition="dialog-bottom-transition" class="container" scrollable>
    <v-card class="content">
      <div class="header">
        <div>
          <h2>Editar serviço</h2>
        </div>
        <div class="actions">
          <div @click="handleRemove()" class="delete-action">
            <v-icon color="#DA4343">mdi-trash-can-outline</v-icon>
          </div>
          <div @click="close()" class="return-action">
            <v-icon color="white">mdi-close</v-icon>
          </div>
        </div>
      </div>
      <div class="form">
        <div class="quantity-form">
          <v-text-field v-model="form.amount" label="Quantidade" type="number" outlined hide-details></v-text-field>
          <v-btn class="quantity-btn-minus" icon @click="decreaseQuantity()">
            <v-icon large class="mt-1">mdi-minus-circle-outline</v-icon>
          </v-btn>
          <v-btn class="quantity-btn-plus" icon @click="form.amount++">
            <v-icon large class="mt-1">mdi-plus-circle-outline</v-icon>
          </v-btn>
        </div>
        <v-text-field v-model="form.unitary_value" label="Valor unitário" v-money="valor" outlined></v-text-field>
        <v-alert dense color="grey lighten-2" icon="mdi-information-outline">
          <div class="text-caption text--secondary">As informações alteradas neste serviço não interferem no cadastro original do mesmo</div>
        </v-alert>
      </div>
      <div class="footer">
        <v-btn color="primary" elevation="0" block @click="save()">Salvar</v-btn>
      </div>
    </v-card>

    <v-dialog v-model="isRemoveDialogActive" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Excluir serviço </v-card-title>
        <v-card-text> Tem certeza que deseja remover este serviço do orçamento atual? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="isRemoveDialogActive = false"> Cancelar </v-btn>
          <v-btn color="red darken-1" text @click="remove"> Remover </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalManageService',
  emits: ['close', 'remove'],
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    service: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isRemoveDialogActive: false,
      form: {
        amount: 0,
        unitary_value: 0
      },
      valor: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      }
    };
  },
  watch: {
    service: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.form = {
            id: newValue.id,
            amount: newValue.amount,
            unitary_value: newValue.unitary_value.toString(),
            service_id: newValue.service_id
          };
        }
      }
    }
  },
  methods: {
    close() {
      this.form = {};

      this.$emit('close');
    },
    handleRemove() {
      this.isRemoveDialogActive = true;
    },
    remove() {
      this.$emit('remove', this.service);

      this.isRemoveDialogActive = false;

      this.close();
    },
    save() {
      if (this.form.amount === 0) {
        this.remove();

        return;
      }

      this.$store.commit('Budget/ALTER_BUDGET_SERVICE', { service: this.form });

      this.close();
    },
    decreaseQuantity() {
      if (this.form.amount > 0) {
        this.form.amount -= 1;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  flex: 1;
  display: flex;
  flex-direction: column;

  .header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    background-color: #3e515f;
    padding: 20px 20px;
    color: #fff;
    z-index: 1;
    border-radius: 0px !important;

    .actions {
      display: flex;
      gap: 16px;
      justify-content: flex-end;
      align-items: center;

      .delete-action,
      .return-action {
        border-radius: 50%;
        padding: 10px;
      }

      .delete-action {
        background-color: white;
      }

      .return-action {
        background-color: #2d3c47;
      }
    }
  }

  .form {
    padding: 20px;
    flex: 1;

    .quantity-form {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
      gap: 24px;

      .quantity-btn-minus,
      .quantity-btn-plus {
        padding: 5px;
        border-radius: 50%;
        border: 1px solid #fff;
        color: #48b38b !important;
      }
    }
  }

  .footer {
    padding: 20px;
  }
}

.v-btn--icon {
  margin: 0 !important;
}

.v-btn--icon.v-size--default {
  height: 24px !important;
  width: 24px !important;
}
</style>
